import { v4 } from 'uuid';

const getUniqueId = () => v4();

export { getUniqueId };
